import React, { useEffect } from "react";
import Footer from '../components/footer';
import Community from '../components/community';
import WhatNext from '../components/whatNetxt';
import ArtistsCurator from '../components/artistsCurator';


import { Link } from '@reach/router';
import LOGOC from "../img/721_logo_color.svg"

import { fetchHotCollections } from "../../store/actions/thunks";
import ExperiencesList from '../components/experiencesList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons"
import Header from '../menu/header';

import Collection from "../components/colletion"


const NavLink = props => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      return {
        className: isCurrent ? 'active' : 'non-active',
      };
    }}
  />
);


const Collections = ({ index, avatar, banner, username, uniqueId }) => {
  return (
    <div>
      <Header />
      <div className="row logo-btn-tap-container" style={{ marginTop: "9rem" }}>
        <div className="col-md-12 col-sm-2 col-xs-1 logo-tap-container" style={{ textAlign: "center" }}>
          <NavLink to="/">
            <img src={LOGOC} alt="Imagen PNG alternativa" style={{ width: "8rem", height: "8rem", marginTop: "1rem" }} />
          </NavLink>
        </div>
      </div>

      <div className='collectible-container container no-top no-bottom'  >
        <div className='row'>
          <div className="col-md-12 col-sm-6 col-xs-1" style={{ textAlign: "center", marginTop: "2rem" }}>
            <hr className="hr-effects3" style={{ height: "0.3rem" }} />
          </div>
          <div className="spacer-double"></div>
          <div className='col-md-12 col-sm-6 col-xs-1 ' style={{ textAlign: "center" }}>
            <h2>Collections</h2>
            <p className="collections-txt-container">
              Las colecciones son un grupo de obras comisariados que refeljan un concepto común y unitario.<br/>
              Cada colección se convierte en única, gracias a la inclusión en ella, de una imagen única autogenerada
              por computadora perteneciente a los <strong>HDM Collectibles.</strong><br/>
              En el interior de cada colección, el coleccionista obtiene la obra de los artistas y esta pieza única que
              representa la edición concretamente.<br/><br/>
              Los ingresos derivados de las ventas de las colecciones son repartidos a aprtes iguales entre los miembros de la colección.  
            </p>
          </div>
        </div>
        <Collection/>
      </div>

      <div className="text-container-colecciones" >
        <button className="btn-main inline lead" style={{ color: "black", background: "white" }}>Share this Collection</button>
      </div>
      {/* */}
      <div className='collectible-container container no-top no-bottom'  ></div>

      <section>
          <span> pagination here</span>
      </section>
      
      <section className='' style={{ background: "#EAEAEA", marginTop: "" }}>
        <div className='row '>
          <div className="col-md-12 col-sm-6 col-xs-1 container" style={{ textAlign: "center", marginTop: "" }}>
            <hr className="hr-effects3" style={{ height: "0.3rem" }} />
          </div>
          <div className="spacer-double  container"></div>
          <div className='col-lg-12  ' style={{ textAlign: "center" }}>
            <h2>Harddiskmuseum</h2>
          </div>
          <div className="col-md-12 col-sm-1 col-xs-1 btn-tap-container" style={{ textAlign: "center" }}>
            <button className="btn-hdm" style={{ marginTop: "0.7rem" }}>Become a Harddiskmuseum artist</button>
          </div>
          <div className="col-md-12 col-sm-1 col-xs-1 btn-tap-container" style={{ textAlign: "center" }}>
            <button className="btn-hdm" style={{ marginTop: "0.7rem" }}>Visit the Museum</button>
          </div>
          <div className="col-md-12 col-sm-1 col-xs-1 btn-tap-container" style={{ textAlign: "center" }}>
            <button className="btn-hdm" style={{ marginTop: "0.7rem" }}>Our blog</button>
          </div>
        </div>
      </section>

      <section className="row" style={{ textAlign: "center" }}>
        <div className="col-md-12 col-sm-1 col-xs-1">
          <Community />
        </div>
      </section>
      <Footer />
    </div>
  );

}

export default Collections;


